module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gvEO2s/tc-custom/9781460381007.jpg?1703706238868",
      "alt": "This image is the cover for the book Sex, Lies and the CEO, Chicago Sons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sex, Lies and the CEO, Chicago Sons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Seducing the billionaire boss is the best way to uncover the truth in this novel of desire and deception from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author. ")]), _c('br'), _c('br'), _vm._v("After his ex writes a tell-all book, CEO Shane Colborn is battling a PR nightmare. The last thing he needs is an affair with another woman, especially one who works for him. But Darci Rivers proves impossible to resist. "), _c('br'), _c('br'), _vm._v("Their passion is intense, but so is Darci’s secret. She’s out to discover a truth that could redeem her father’s legacy—and destroy Shane’s company, taking him down with it. Will she do what she’s come to do . . . and risk the once-in-a-lifetime connection she’s found with her boss?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Dunlop\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times and USA Today bestselling author Barbara Dunlop has written more than forty novels for Harlequin Books, including the acclaimed COLORADO CATTLE BARONS series for Harlequin Desire. Her sexy, light-hearted stories regularly hit bestsellers lists. Barbara is a three time finalist for the Romance Writers of America's RITA award.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0